// extracted by mini-css-extract-plugin
export default {"tags_wrapper":"TagsSelect_tags_wrapper__+b67x","tag_wrapper":"TagsSelect_tag_wrapper__ZR2+-","tag":"TagsSelect_tag__-xPXR","color":"TagsSelect_color__6kJih"};